import type { DemandeAdmin } from './types.ts'

export const ETATS: Record<string, string> = {
  en_cours: 'En cours',
  en_attente_approbation: 'À approuver',
  en_attente_paiement: 'Paiement attendu',
  confirmee: 'Confirmée',
  refusee: 'Refusée',
  annulee: 'Annulée',
  expiree: 'Expirée',
}

export function libelleEtat(etat: string): string {
  return ETATS[etat] ?? etat.replaceAll('_', ' ')
}

export function filtrerDemandes(
  demandes: DemandeAdmin[],
  recherche: string,
  etat: string,
  service = '',
): DemandeAdmin[] {
  const normaliser = (texte: string) =>
    texte
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
  const mots = normaliser(recherche.trim()).split(/\s+/).filter(Boolean)
  return demandes.filter(
    (d) =>
      (!etat || d.etat === etat) &&
      (!service || d.service_cle === service) &&
      mots.every((mot) =>
        normaliser(
          [d.demandeur, d.courriel, d.service_cle, d.ressource, d.id]
            .filter(Boolean)
            .join(' '),
        ).includes(mot),
      ),
  )
}

export function dateLongue(valeur: string, fuseau = 'America/Toronto'): string {
  const date = new Date(valeur)
  return Number.isNaN(date.getTime())
    ? valeur
    : new Intl.DateTimeFormat('fr-CA', {
        dateStyle: 'medium',
        timeStyle: 'short',
        timeZone: fuseau,
      }).format(date)
}

export function periodeLisible(
  demande: DemandeAdmin,
  fuseau = 'America/Toronto',
): string {
  const parties = demande.periode?.split(' → ')
  if (parties?.length === 2 && parties[0] && parties[1]) {
    const debut = new Date(parties[0]),
      fin = new Date(parties[1])
    if (!Number.isNaN(debut.getTime()) && !Number.isNaN(fin.getTime())) {
      return new Intl.DateTimeFormat('fr-CA', {
        dateStyle: 'medium',
        timeStyle: 'short',
        timeZone: fuseau,
      }).formatRange(debut, fin)
    }
  }
  return demande.debut_utc
    ? dateLongue(demande.debut_utc, fuseau)
    : demande.periode || 'Créneau à choisir'
}
